<template>
  <b-card>
    <template slot="header">
      <b-row>
        <b-button @click="$router.go(-1)" class="breadcrumb-back-btn" size="sm" variant="link"><i
          class="fa fa-chevron-left fa-fw" aria-hidden="true"></i></b-button>
        <h5 style="align-self: end">{{ $t('CLIENTS') }}</h5>
        <div style="align-self: center" class="ml-4">
          <b-form-radio-group
            id="radio-group-2"
            v-model="selected"
            name="radio-sub-component"
          >
            <b-form-radio :value="PHYSICAl_PERSON">Fizičko lice</b-form-radio>
            <b-form-radio :value="LEGAL_ENTITY">Pravno lice</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-row>
    </template>
    <ClientLegalEntityForm v-if="selected === LEGAL_ENTITY" @success="close"/>
    <ClientForm v-if="selected === PHYSICAl_PERSON" @success="close"/>
  </b-card>
</template>

<script>
import ClientForm from "@/components/client/ClientForm";
import ClientLegalEntityForm from "@/components/client/ClientLegalEntityForm";

export default {
  name: "Index",
  components: {ClientLegalEntityForm, ClientForm},
  data() {
    return {
      LEGAL_ENTITY: 1,
      PHYSICAl_PERSON: 2,
      selected: 2,
    }
  },
  methods: {
    close() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
